export default {"src":"/_next/static/media/douches.bc529281.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};